import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=6d15e88a&"
import script from "./order-detail.vue?vue&type=script&lang=ts&"
export * from "./order-detail.vue?vue&type=script&lang=ts&"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=6d15e88a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports